import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { N600, N900 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import {
  updateLoggedInFormInput,
  useAppDispatch,
  useAppSelector
} from '../../../../redux';
import { fontCharlieDisplay } from '../styled';
import { useDevopsState } from '../../hook';
import {
  InputSitename,
  InputSitenameExisting,
  MarketingConsentCheckBox
} from '../component';
import { messages } from '../../messages';

export function SlideSitenameExisting() {
  const { locale, userInfo, featureFlags, devopsImageUrls } = useDevopsState();
  const dispatch = useAppDispatch();
  const showMarketingConsent = locale.localeRequiresMarketingCommunicationOptIn;
  useEffect(() => {
    if (
      userInfo !== undefined &&
      userInfo.sites !== null &&
      userInfo.sites.length > 1
    ) {
      dispatch(updateLoggedInFormInput(false));
    }
  }, [userInfo]);

  const { isNewSiteInput } = useAppSelector(
    ({ formInputSelection }) => formInputSelection
  );

  const generalSlideSitenameExisting = (
    <>
      <Header>
        <SanitizedFormattedHtmlMessage {...messages.slideExistingSiteHeader} />
      </Header>
      <Description>
        <SanitizedFormattedHtmlMessage
          {...messages.slideExistingSiteSubHeader}
        />
      </Description>
      {isNewSiteInput && <InputSitename />}
      {!isNewSiteInput && <InputSitenameExisting />}
      {showMarketingConsent && <MarketingConsentCheckBox controlled={true} />}
    </>
  );
  const codeawsSlideSitenameExisting = (
    <>
      <HeaderCodeAws>
        <SanitizedFormattedHtmlMessage {...messages.slideExistingSiteHeader} />
      </HeaderCodeAws>
      <CodeAwsDescription>
        <SanitizedFormattedHtmlMessage
          {...messages.slideExistingSiteSubHeader}
        />
      </CodeAwsDescription>
      <DevopsCodeAwsImgWrapper>
        <img alt="" src={devopsImageUrls.codeAwsJsw} />
      </DevopsCodeAwsImgWrapper>
      {isNewSiteInput && <InputSitename />}
      {!isNewSiteInput && <InputSitenameExisting />}
      {showMarketingConsent && <MarketingConsentCheckBox controlled={true} />}
    </>
  );

  return featureFlags.enableUseCodeAWSContent
    ? codeawsSlideSitenameExisting
    : generalSlideSitenameExisting;
}

const Header = styled.h1`
  font-family: ${fontCharlieDisplay};
  font-style: normal;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  font-size: 32px;
  line-height: 30px;
  color: ${N600};
  letter-spacing: 0.3px;
  max-width: 300px;
  margin: 0 auto 30px auto;
  text-align: center;

  @media only screen and (max-width: 769px) {
    font-size: 24px;
    line-height: 20px;
    text-align: center;
  }
`;

const HeaderCodeAws = styled.h1`
  font-family: ${fontCharlieDisplay};
  font-style: normal;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  font-size: 40px;
  line-height: 30px;
  color: ${N600};
  letter-spacing: 0.3px;
  max-width: 300px;
  margin: 0 auto 30px auto;
  text-align: center;

  @media only screen and (max-width: 769px) {
    font-size: 24px;
    line-height: 20px;
    text-align: center;
  }
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 300;
  color: ${N900};
  line-height: 28px;
  letter-spacing: -0.7px;
  text-align: center;
  margin-bottom: 42px;

  @media only screen and (max-width: 769px) {
    font-size: 18px;
    line-height: 26px;
    text-align: center;
  }
`;

const CodeAwsDescription = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 300;
  color: ${N900};
  line-height: 28px;
  letter-spacing: -0.7px;
  text-align: center;
  margin-bottom: 10px;

  @media only screen and (max-width: 769px) {
    font-size: 18px;
    line-height: 26px;
    text-align: center;
  }
`;

const DevopsCodeAwsImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  height: 130px;
  width: auto;

  @media only screen and (max-width: 769px) {
    margin-top: 16px;
    padding-bottom: 20px;
  }
`;
